import React, { useState, useEffect, useMemo } from "react";
import { FaPen, FaTrash, FaSortUp, FaSortDown } from "react-icons/fa";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import DeleteTask from "./Assets/DeleteModal";

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const navigate = useNavigate();
  
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
  // Fetch products
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if(!token){
        navigate('/login');
        return;
      }
      const response = await fetch("https://viklang.serverscripts.in/api/v1/product/view", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
        if (response.status === 401) {
        toast.error("Session expired, please log in again");
        localStorage.removeItem("authToken");
        navigate('/login');
        return;
      }
      const result = await response.json();
      if (result.success) setProducts(result.data);
      else toast.error(result.message);
    } catch {
      toast.error("Failed to fetch products");
    }
  };

  // Sorting logic
  const sortData = (key, direction) => {
    const sorted = [...products].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setProducts(sorted);
    setSortConfig({ key, direction });
  };

  const renderSortButtons = (key) => (
    <span className="ml-2 inline-flex flex-col">
      <button
        onClick={() => sortData(key, "asc")}
        className={`text-xs ${
          sortConfig.key === key && sortConfig.direction === "asc"
            ? "text-gray-800"
            : "text-gray-300"
        } hover:text-gray-600`}
      >
        <FaSortUp />
      </button>
      <button
        onClick={() => sortData(key, "desc")}
        className={`text-xs -mt-1 ${
          sortConfig.key === key && sortConfig.direction === "desc"
            ? "text-gray-800"
            : "text-gray-300"
        } hover:text-gray-600`}
      >
        <FaSortDown />
      </button>
    </span>
  );

  
  const filteredProducts = useMemo(() => {
    if (!search.trim()) return products;
    return products.filter((p) =>
      p.name?.toLowerCase().includes(search.toLowerCase()) ||
      p.category_name?.toLowerCase().includes(search.toLowerCase())
    );
  }, [products, search]);

  const handleEditClick = (id) => {
    navigate(`/product-edit/${id}`);
  };

  const handleDeleteClick = (id) => {
      setItemToDelete(id);
      setDeleteModalShow(true);
    };
  
    const confirmDelete = async () => {
      try {
        const response = await fetch(`https://viklang.serverscripts.in/api/v1/product/delete/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({ id: itemToDelete }),  
        });
      
        const errorText = await response.json();
        if (!response.ok) {
  
          toast.error(errorText.message || "Failed to delete task");
          return;
        }
  
        toast.success(errorText.message || "Task deleted successfully");
      } catch (error) {
        console.error("Error deleting task:", error);
      }
      fetchData();
      setDeleteModalShow(false);
      setItemToDelete(null);
      
    };
  
    const cancelDelete = () => {
      setDeleteModalShow(false);
      setItemToDelete(null);
    };
  return (
    <div className="p-5 bg-gray-50 min-h-screen">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-semibold text-gray-700">Product List</h2>
        <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition">
          <a href="/product-add">Add New Product</a>
        </button>
      </div>

      
      <div className="flex items-center justify-end mb-6">
        <input
          type="text"
          placeholder="Search by Product Title..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      
      <div className="overflow-x-auto bg-white shadow rounded-lg">
        <table className="min-w-full border border-gray-200">
          <thead className="bg-blue-600 text-white">
            <tr>
              <th className="py-2 px-4 text-left">
                #
                
              </th>
              <th className="py-2 px-4 text-left">
                Product Title
                
              </th>
              <th className="py-2 px-4 text-left">
                Category
                
              </th>
              <th className="py-2 px-4 text-center">
                Created At
                
              </th>
              <th className="py-2 px-4 text-center">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200">
            {filteredProducts.length === 0 ? (
              <tr>
                <td colSpan="5" className="py-4 text-center text-gray-500">
                  No products found.
                </td>
              </tr>
            ) : (
              filteredProducts.map((product, index) => (
                <tr
                  key={product.id}
                  className="hover:bg-gray-50 transition duration-150"
                >
                  <td className="py-3 px-4">{index + 1}</td>

                  <td className="py-3 px-4 flex items-center gap-3">
                    <img
                      src={product.img}
                      alt={product.name}
                      className="h-16 w-16 object-cover"
                    />
                    <div>
                      <div className="font-semibold text-gray-800">
                        {product.name}
                      </div>
                      {/* <div className="text-sm text-gray-500">
                        Code: {product.code || "12345"}
                      </div> */}
                    </div>
                  </td>

                  <td className="py-3 px-4 text-gray-700">
                    <span className="font-semibold">{product.category_name}</span>
                  </td>

                  <td className="py-3 px-4 text-center">
                    {product.created_at}
                  </td>

                  <td className="py-3 px-4 text-center">
                    <div className="flex items-center justify-center gap-3">
                      <button className="text-blue-500 hover:text-blue-700" onClick={() => handleEditClick(product.id)}>
                        <FaPen />
                      </button>
                      <button className="text-red-500 hover:text-red-700" onClick={() => handleDeleteClick(product.id)}>
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {deleteModalShow && (
              <DeleteTask
                itemName={
                  filteredProducts.find((p) => p.id === itemToDelete)?.name || "Unknown Product"
                }
                onClose={cancelDelete}
                onDelete={confirmDelete}
              />
            )}
    </div>
  );
};

export default ProductList;
